(function () {

    'use strict';

    angular.module('Services').factory('FleetDriversTableService', FleetDriversTableService);
    FleetDriversTableService.$inject = ['$location', 'FleetService', 'TableLiteFactory', 'toastr', '$uibModal'];
    function FleetDriversTableService($location, FleetService, TableLiteFactory, toastr, $uibModal) {
        return function (options = {}) {
            const driverGroupId = angular.getObjVal(options, 'filter.driverGroupId');

            const headers = {
                driverId: {
                    label: 'Driver ID',
                    viewName: 'driverId',
                    filterName: 'driverId',
                    filter: {
                        type: 'text',
                        placeholder: 'Search',
                        onSubmit: function (header) {
                            sendRequest(evaluateFilter(header));
                        }
                    },
                    headerFn: function () {
                        sort(this.filterName);
                    }
                },
                lastName: {
                    label: 'Last Name',
                    viewName: 'lastName',
                    filterName: 'lastName',
                    filter: {
                        type: 'text',
                        class: 'bba-ref-no',
                        placeholder: 'Search',
                        onSubmit: function (header) {
                            sendRequest(evaluateFilter(header));
                        },
                        model: '' //optional
                        //text and inputDropdown uses `model` attribute for ng-model
                    },
                    headerFn: function () {
                        sort(this.filterName);
                    }
                },
                firstName: {
                    label: 'First Name',
                    viewName: 'firstName',
                    filterName: 'firstName',
                    filter: {
                        type: 'text',
                        class: 'bba-ref-no',
                        placeholder: 'Search',
                        onSubmit: function (header) {
                            sendRequest(evaluateFilter(header));
                        },
                        model: '' //optional
                        //text and inputDropdown uses `model` attribute for ng-model
                    },
                    headerFn: function () {
                        sort(this.filterName);
                    }
                },
                email: {
                    label: 'Email',
                    viewName: 'email',
                    filterName: 'email',
                    filter: {
                        type: 'text',
                        class: 'bba-ref-no',
                        placeholder: 'Search',
                        onSubmit: function (header) {
                            sendRequest(evaluateFilter(header));
                        },
                        model: '' //optional
                        //text and inputDropdown uses `model` attribute for ng-model
                    },
                    headerFn: function () {
                        sort(this.filterName);
                    }
                },
                vehicle: {
                    label: 'Vehicle Plate Number',
                    viewName: 'vehicleName',
                    filterName: 'currentVehicle.plateNumber',
                    filter: {
                        type: 'text',
                        class: 'bba-ref-no',
                        placeholder: 'Search',
                        onSubmit: function (header) {
                            sendRequest(evaluateFilter(header));
                        },
                        model: '' //optional
                        //text and inputDropdown uses `model` attribute for ng-model
                    },
                    headerFn: function () {
                        sort(this.filterName);
                    }
                },
                driverGroup: {
                    label: 'Driver Group',
                    viewName: 'group',
                    filterName: 'driverGroupName',
                    filter: {
                        type: 'text',
                        class: 'bba-ref-no',
                        placeholder: 'Search',
                        onSubmit: function (header) {
                            sendRequest(evaluateFilter(header));
                        },
                        model: '' //optional
                        //text and inputDropdown uses `model` attribute for ng-model
                    },
                    headerFn: function () {
                        sort(this.filterName);
                    }
                },
                fleet: {
                    label: 'Fleet',
                    viewName: 'fleetName',
                    filterName: 'fleetName',
                    filter: {
                        type: 'text',
                        class: 'bba-ref-no',
                        placeholder: 'Search',
                        onSubmit: function (header) {
                            sendRequest(evaluateFilter(header));
                        },
                        model: '' //optional
                        //text and inputDropdown uses `model` attribute for ng-model
                    },
                    headerFn: function () {
                        sort(this.filterName);
                    }
                },
                status: {
                    label: 'Status',
                    viewName: 'status',
                    filterName: 'active',
                    filter: {
                        type: 'select2',
                        placeholder: 'Select One',
                        items: ['Active', 'Inactive'],
                        onSelect: function (header) {
                            const filter = {};
                            filter[header.filterName] = header.filter.model === 'Active';
                            sendRequest(filter);
                        }
                    },
                    headerFn: function () {
                        sort(this.filterName);
                    }
                }
            };
            const tableData = {
                tableName: 'FleetDriversTable',
                optionAddOns: {
                    buttons: [{
                        class: 'btn-primary',
                        label: 'Add New',
                        tooltip: 'Add New',
                        onClick: options.onAddVehicle || (() => {
                            $location.path('/fleets/drivers/add').search(angular.extend({}, options.filter));
                        })
                    }]
                },
                config: {
                    noPagination: false,
                    noHeaders: false,
                    noItemsView: false,
                    noTableFooter: false,
                },
                headers: [],
                data: [],
                rowOnClick: options.rowOnClick || (driver => {
                    $location.path('/fleets/drivers/details/' + driver.id).search(angular.extend({}, options.filter));
                })
            };
            if(driverGroupId){
                tableData.optionAddOns.buttons.push({
                    class: 'btn-primary',
                    label: 'Assign existing',
                    tooltip: 'Assign existing driver',
                    onClick: (() => {
                        $uibModal.open({
                            animation: true,
                            ariaLabelledBy: 'modal-title',
                            ariaDescribedBy: 'modal-body',
                            templateUrl: '/templates/pages/fleets/modals/driverSelect.html',
                            controller: function ($uibModalInstance) {
                                let vm = this;
                                vm.select = select;
                                vm.cancel = cancel;
                                vm.searchDriver = searchDriver;

                                function searchDriver(select) {
                                    if(!select.open)
                                        return false;
                                    vm.searching = true;
                                    vm.drivers = [];
                                    FleetService.Drivers.getAll(data=>{
                                        vm.drivers = data.content.filter(driver=>{
                                            if(driverGroupId){
                                                return angular.getObjVal(driver, 'driverGroup.id') !== driverGroupId
                                            }
                                        });
                                        vm.searching = false;
                                    }, error=> {
                                        vm.searching = true;
                                        toastr.error('Unable to search for driver', error.message);
                                    }, {
                                        plateNumber: select.search,
                                        hasDriver: false,
                                        size: 40
                                    })
                                }

                                function select() {
                                    FleetService.Drivers.update(vm.driver.id, cleanPayload(vm.driver),function () {
                                        $uibModalInstance.close();
                                    }, function () {
                                        toastr.error('Please try again later', 'Unable to assign driver');
                                        $uibModalInstance.dismiss();
                                    });
                                }

                                function cancel() {
                                    $uibModalInstance.dismiss();
                                }
                            },
                            controllerAs: 'vm',
                            size: 'md',
                            appendTo: $('body')
                        }).result.then(()=>{
                            sendRequest();
                        });
                    })
                });
            }
            const tableActions = new TableLiteFactory(tableData,
                {
                    serviceCallback: FleetService.Drivers.getAll,
                    callbackFormat: ['success', 'error', 'filter'],
                    postRequestCallback: data => {
                        buildTableData(data);
                    },
                    postRequestErrorCallback: err => {
                        buildTableData(null);
                        toastr.error(err);
                    },
                    defaultFilters: angular.extend({
                        size: 20,
                        page: 0,
                        sort: 'id,desc'
                    }, options.filter || {})
                }
            );
            const sort = tableActions.sort;
            const evaluateFilter = tableActions.evaluateFilter;
            const sendRequest = tableActions.sendRequest;

            function buildTableData(data) {
                /*** START - Building of Data ***/

                tableActions.initializeTableData(data);
                if (!data)
                    return null;
                angular.forEach(data.content, function (fleet, index) {
                    fleet.status = {
                        type: 'status',
                        status: fleet.active,
                        label: fleet.active ? 'Active' : 'Inactive'
                    };
                    fleet.group = angular.getObjVal(fleet, 'driverGroup.name') || 'N/A'
                    fleet.vehicleName = angular.getObjVal(fleet, 'currentVehicle.plateNumber') || 'N/A';
                    fleet.fleetName = angular.getObjVal(fleet, 'fleet.name') || 'N/A';
                    // fleet.href = '/fleets/details/' + fleet.id;

                    tableData.data.push(fleet);
                });
                /*** END - Building of Data ***/
            }

            (()=>{
                for(let key in headers){
                    if(angular.getObjVal(options, 'exclude.length')){
                        options.exclude.forEach(head=>{
                            if(head !== key){
                                tableData.headers.push(headers[key]);
                            }
                        })
                    }else{
                        tableData.headers.push(headers[key]);
                    }
                }
            })();

            function cleanPayload(payload) {
                const {
                    active,
                    addressLine1,
                    addressLine2,
                    driverGroup,
                    driverId,
                    email,
                    firstName,
                    fleet,
                    lastName,
                    licenseNumber,
                    licensePhotoUrl,
                    driverPhotoUrl,
                    location,
                    phone1,
                    phone2,
                    currentVehicle,
                    routeId
                } = payload;
                return {
                    active,
                    addressLine1,
                    addressLine2,
                    driverGroupId: driverGroupId || angular.getObjVal(driverGroup, 'id') || null,
                    driverId,
                    email,
                    firstName,
                    fleetId: angular.getObjVal(fleet,'id') || null,
                    lastName,
                    licenseNumber,
                    licensePhotoUrl,
                    driverPhotoUrl,
                    location: angular.getObjVal(location, 'id') || null,
                    phone1,
                    phone2,
                    vehicleId: angular.getObjVal(currentVehicle, 'id') || null,
                    routeId
                }
            }

            this.tableData = tableData;
        }
    }
})();



// WEBPACK FOOTER //
// ./js/services/tables/FleetDriversTableService.js